/**
 * Created by Jerker Nord on 2023-12-05.
 */
import {LonerContainer} from "./LonerContainer";
import {gsap} from "gsap";
import {LonerSymbol} from "../reels/symbols/main/LonerSymbol";

export class LonerWinLineContainer extends LonerContainer {

    //private _currentStateSprites: PIXI.Sprite[];
    private _mainContainer:PIXI.Container;
    private _pinContainer:PIXI.Container;
    private _threadContainer:PIXI.Container;
    private _pinAndThreadContainer:PIXI.Container;
    private _winComboSymbols:LonerSymbol[];

    constructor() {
        super();
        this.init();
    }

    private init():void {
        this.visible = false;
        this._mainContainer = new PIXI.Container()
        this.addChild(this._mainContainer);
        this._pinAndThreadContainer = new PIXI.Container();
        this.addChild(this._pinAndThreadContainer);
        this._threadContainer = new PIXI.Container();
        this._pinAndThreadContainer.addChild(this._threadContainer);
        this._pinContainer = new PIXI.Container();
        this._pinAndThreadContainer.addChild(this._pinContainer);

        this._winComboSymbols = [];
    }

    public getFadeOutTL():gsap.core.Timeline {
        const fadeOutTL:gsap.core.Timeline = gsap.timeline();
        fadeOutTL.add([
            () => {
                if(this.pinAndThreadContainer.alpha == 1) {
                    gsap.to(this.pinAndThreadContainer, {
                        duration : 0.1,
                        alpha : 0
                    })
                }
            }
        ])

        return fadeOutTL;
    }

    public getFadeInTL():gsap.core.Timeline {
        const fadeInTL:gsap.core.Timeline = gsap.timeline();
        fadeInTL.add([
            () => {
                if(this.pinAndThreadContainer.alpha == 0) {
                    gsap.to(this.pinAndThreadContainer, {
                        duration : 0.1,
                        alpha : 1
                    })
                }
            }
        ])

        return fadeInTL;
    }

    get pinContainer():PIXI.Container {
        return this._pinContainer;
    }

    get threadContainer():PIXI.Container {
        return this._threadContainer;
    }

    get mainContainer():PIXI.Container {
        return this._mainContainer;
    }

    get pinAndThreadContainer():PIXI.Container {
        return this._pinAndThreadContainer;
    }

    get winComboSymbols():LonerSymbol[] {
        return this._winComboSymbols;
    }

    public reset():void {
        this.visible = false;
        this._winComboSymbols = [];
        this._pinContainer.removeChildren();
        this._threadContainer.removeChildren();
        this._mainContainer.removeChildren();
        this.alpha = 1;
        this.position.x = 0;
        this.position.y = 0;
        this.isUsed = false;
    }
}